const ROOT = 'properties/'

export default {
	show: `${ROOT}`,
	arrayListFilesByAlbumsTypes: `${ROOT}albums/list-files-by-albums-types`
}
